// EmailJS Configuration
// Replace these values with your actual EmailJS account details

export const EMAILJS_CONFIG = {
  serviceId: 'service_hd8s15r',  // Your EmailJS service ID
  templateId: 'template_zfro1v6', // Your EmailJS template ID
  publicKey: 'S0krUTVGPYB_dqB5E', // Your EmailJS public key (use exactly as provided in dashboard)
};
